"use client";
import { ReactNode } from "react";
import { BrandContextType, HolidayQuoteBrandContext } from "./holiday-quote-brand-context";


export function HolidayQuoteBrandProvider({
  children, value,
}: {
  children: ReactNode;
  value: BrandContextType;
}) {
  return (
    <HolidayQuoteBrandContext.Provider value={value}>
      {children}
    </HolidayQuoteBrandContext.Provider>
  );
}
